module.exports = __webpack_public_path__ + "assets/dashboard-icon-videosPlayed.f3824c2a.svg";